import { render, staticRenderFns } from "./CoursewareStructuralElement.vue?vue&type=template&id=752908c0&"
import script from "./CoursewareStructuralElement.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports